const environment = {
  AESEncryptSecretKey: "AESEncryptSecretKey"
};

export { environment };